import { Form, Input, Row, Column } from '@bancobarigui/barihaus';
import { MaskedInput } from '@/shared/components/MaskedInput';

import { PhoneTypeFormItem } from '@/components/PhoneTypeFormItem';

export function ProviderForm() {
  return (
    <Row gutter={[24, 16]}>
      <Column span={12}>
        <Form.Item
          name="cnpj"
          label="CNPJ"
          rules={[{ required: true, message: 'Informe o CNPJ da Provedora.' }]}
        >
          <MaskedInput mask="00.000.000/0000-00" placeholder="XX.XXX.XXX/XXXX-XX" />
        </Form.Item>
      </Column>

      <Column span={12}>
        <Form.Item
          name="integrationCode"
          label="Cód. de Integração*"
          rules={[{ required: true, message: 'Informe o código de integração.' }]}
        >
          <Input />
        </Form.Item>
      </Column>

      <Column span={12}>
        <Form.Item
          label="Nome"
          name="name"
          rules={[{ required: true, message: 'Informe o nome da Provedora.' }]}
        >
          <Input />
        </Form.Item>
      </Column>

      <Column span={12}>
        <Form.Item
          name="shortName"
          label="Nome Abreviado"
          rules={[{ required: true, message: 'Informe o nome abreviado da Provedora.' }]}
        >
          <Input />
        </Form.Item>
      </Column>

      <Column span={12}>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Informe o email da Provedora.' },
            { type: 'email', message: 'Informe um email válido.' },
          ]}
        >
          <Input type="email" placeholder="email@exemplo.com" />
        </Form.Item>
      </Column>

      <Column span={12}>
        <PhoneTypeFormItem />
      </Column>
    </Row>
  );
}
